export default "__VITE_ASSET__Cg77EZtW__"